import React from 'react'
import PagesHeader from '../common/components/PagesHeader'
import FAQ from '../common/components/FAQ'
import ApplyStepsContainer from './ApplyStepsContainer'
import MortgageCalculatorsContainer from './MortgageCalculatorsContainer'
import UsefulArticles from './UsefulArticles'
import PartnersCTA from '../common/components/PartnersCTA'

function App() {
  return(
    <div>
      <div className="jumbotron jumbotron-fluid jumbotron-fixed-height pb-0 how-to-apply-header">
        <div className="container">
          <PagesHeader
            header='How to apply for a Yard loan'
            body="Get started online. We’ve made it easy to apply for a new home loan, conditional approval or switch from another lender."
          />
        </div>
      </div>
      <ApplyStepsContainer />
      <FAQ />
      <MortgageCalculatorsContainer />
      <UsefulArticles />
      <PartnersCTA />
    </div>
  )
}

export default App
